import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Modal } from "antd";
import Button from "../components/shared/button";
import ReminderDeleted from "./reminderDeleted";

const DelTaskCardModal = ({ isdelModalOpen, setIsdelModalOpen }) => {
  const navigate = useNavigate();
  const [isDeletedModalOpen, setIsDeletedModalOpen] = useState(false);

  const handleOk = () => {
    setIsdelModalOpen(false);
  };

  const handleCancel = () => {
    setIsdelModalOpen(false);
  };

  const handleDelete = () => {
    setIsdelModalOpen(false);
    setIsDeletedModalOpen(true);

    setTimeout(() => {
      setIsDeletedModalOpen(false);
    }, 1000);
  };

  return (
    <>
      <Modal
        open={isdelModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        className="del-modal"
        centered={true}
        width="35%"
      >
        <div className="modal-content flex flex-col items-center p-[34px] gap-[24px]">
          <h5 className="text-blue font-manrope text-center font-medium max-w-[327px]">
            Are you sure you want to delete this task?
          </h5>
          <div className="flex gap-[8px]">
            <Button
              text="Yes"
              className="button btn-blue-border rounded-[39px] large"
              height={45}
              width={142}
              onClick={handleDelete}
            />
            <Button
              text="No"
              className="button btn-blue !rounded-[39px] large"
              height={45}
              width={142}
              onClick={handleCancel}
            />
          </div>
        </div>
      </Modal>

      <ReminderDeleted
        isDeletedModalOpen={isDeletedModalOpen}
        setIsDeletedModalOpen={setIsDeletedModalOpen}
      />
    </>
  );
};

export default DelTaskCardModal;
